<template>
        <section class="content-header" style="margin-top: -40px;">
            <div class="row ">
                <div class="col-md-8" style="padding:0px;">
                    <trabajosrealizadostotales 
                        @subsanarmarcados="subsanarMarcados"
                        @todosmarcados="marcarTrabajos"
                        :actualizartotales="actualizartotales"
                        :recargar="recargar" 
                        :id="id" 
                        :totalrent="totalrent" 
                        :servicio="servicio" 
                        :totalcliente="totalcliente" 
                        :totaloperario="totaloperario" 
                        :operarios="operarios" /> 
                </div>
                <div class="col-md-4 text-right">  
                    <div class="row">
                        <div class="col-md-8">   
                            <div class="btn-group btn-group-toggle btn-sm" data-toggle="buttons" :title="$t('general.filtrarpor')">
                                <label class="btn btn-outline-secondary" :class="{ 'active': selectedOption === 'option_b3' }">
                                    <input type="radio" name="options" id="option_b3" value="option_b3" v-model="selectedOption" @change="mostrartodo()" checked autocomplete="off"> {{$t('general.todos')}}
                                </label>
                                <label class="btn btn-outline-secondary" :class="{ 'active': selectedOption === 'option_b1' }">
                                    <input type="radio" name="options" id="option_b1" value="option_b1" v-model="selectedOption" @change="togglecliente()" autocomplete="off"> {{$t('general.a cliente')}}
                                </label>
                                <label class="btn btn-outline-secondary" :class="{ 'active': selectedOption === 'option_b2' }">
                                    <input type="radio" name="options" id="option_b2" value="option_b2" v-model="selectedOption" @change="toggleoperario()" autocomplete="off"> {{$t('general.a operario')}}
                                </label>
                            </div>
                        </div>
                        <div :class="facturaClass" class="col-md-4" style="margin: 0; height: 42px; display: flex; justify-content: center; align-items: center">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="checkfacturar" class="custom-control-input" @change="comprobarFacturar()" id="para_facturar">
                                <label class="custom-control-label" for="para_facturar">{{ no_factura == 1 ? 'Para registrar' : $t('general.para facturar')}}</label>
                            </div>                            
                        </div>
                    </div>
                </div>
                <div class="col-md-12 d-flex justify-content-end mt-2" v-if="this.servicio?.compania?.sistema == 'ELBA_WS'">
                    <div style="align-items: center">  
                            <button type="button" style="height:42px; width:150px" class="btn btn-info btn-sm font-weight-bold" @click="abrirModalElba()">            
                                {{$t('general.facturacion_elba')}}                                                                                  
                            </button>                                                                                              
                    </div>
                </div>    
            </div>
        </section>
        <section class="content">
            <div class="col-md-12" style="display: flex; flex-flow: row; justify-content: space-between; margin-bottom: 15px; padding:0px;" >
                <!--<div title="Marcar todos los trabajos" class="card" style="margin: 0;width: 300px; height: 42px;">
                    <div class="card-body" style="display: flex; justify-content: space-between; align-items: center; padding-right: 0;">
                        <div style="display: flex; align-items: center; gap: 10px;">
                            <input style="width: 17px; height: 17px;" type="checkbox" v-model="marcadosTodos" @change="marcarTodos()">
                            <label style="margin: 0">Marcar todos</label>
                        </div>
                        <button type="button" class="btn btn-secondary btn-sm" title="Subsanar todos los trabajos marcados"
                                @click="subsanarTrabajos()"><i class="fas fa-tools"></i>&nbsp;Subsanar</button>
                    </div>
                </div>-->
                <Button type="button" v-if="operariostrabajo !='' && mostrarboton==true" @click="mostrarnuevooperario = !mostrarnuevooperario" style="font-size:small;" title="Nuevo trabajo" class="btn btn-info">Nuevo trabajo de operario con visita</Button>
                
                <div v-if="this.servicio && this.servicio.compania.sistema=='FUNCIONA'" style="display: flex; gap: 15px;">
                    <Button @click="generarAlbaran()" type="button" style="font-size:small;" class="btn btn-info">Generar Albarán</Button>
                </div> 

                <div v-if="mostrarFacturacionMutua" style="display: flex; gap: 15px;">
                    <Button type="button" @click="$refs.valMutua.cargarTrabajos(); mostrarValMutua = true" style="font-size:small;" title="Valoraciones actuales de mutua" class="btn btn-info">Valoraciones de mutua</Button>
                </div>

                <!-- PRESUVALAXA -->
                <div v-if="mostrarFacturacionAxa" style="display: flex; gap: 15px;">
                    <Button type="button" @click="$refs.presAxa.cargarTrabajos(); mostrarPresAxa = true" style="font-size:small;" title="Presupuestos actuales de axa" class="btn btn-info">Presupuestos de axa</Button>
                    <Button type="button" @click="$refs.valAxa.cargarTrabajos(); mostrarValAxa = true" style="font-size:small;" title="Valoraciones actuales de axa" class="btn btn-info">Valoraciones de axa</Button>
                </div>
 
 
           

                <!-- <Button type="button" v-if="proveedoreslista.length>0"  @click="mostrarnuevoproveedor = !mostrarnuevoproveedor"  title="Añadir proveedor" class="btn btn-warning">Faltan Proveedores por añadir</Button> -->
            </div>
         <PresupuestosAxa ref="presAxa" :visible="mostrarPresAxa" @cerrar="mostrarPresAxa = false" @update:visible="mostrarPresAxa = false" :id="id" v-if="servicio && servicio.compania.sistema=='AXA_WS'"/>
         <ValoracionesAxa ref="valAxa" :visible="mostrarValAxa" @cerrar="mostrarValAxa = false" @update:visible="mostrarValAxa = false" :id="id" v-if="servicio && servicio.compania.sistema=='AXA_WS'"/>
         <ValoracionesMutua ref="valMutua" :visible="mostrarValMutua" @cerrar="mostrarValMutua = false" @update:visible="mostrarValMutua = false" :id="id" v-if="servicio && servicio.compania.sistema=='MUTUA'"/>

         <div v-if="mostrarnuevoproveedor" class="col-md-12" style="padding:0px;">
            <select style="width:25%" v-if="mostrarnuevoproveedor" class="form-control" v-model="proveedorseleccionado">
                        <option hidden selected disabled value="">Selecciona Proveedor</option>
                        <option v-for="proveedor in proveedoreslista" :key="proveedor.id" :value="proveedor.id">{{ proveedor.nombre }}</option>
            </select>
            <br>
         </div>
         <div class="col-md-12" v-if="proveedorseleccionado && mostrarnuevoproveedor" style="padding:0px;">
            <TrabajoRealizadoNuevoProveedor :id="id" :proveedor="proveedorseleccionado"  :operariostrabajo="operariostrabajo" :servicio="servicio">
            </TrabajoRealizadoNuevoProveedor>
            <p>&nbsp;</p> 
         </div>
         <div class="col-md-12" v-if="mostrarnuevooperario && mostrarboton==true && operariostrabajo !=''" style="padding:0px;">
            <TrabajoRealizadoNuevoOperario :id="id"  :operariostrabajo="operariostrabajo" :servicio="servicio">
            </TrabajoRealizadoNuevoOperario>
            <p>&nbsp;</p> 
         </div>
         <div class="card card-warning" v-if="!haytrabajos" style="padding:0px;">
            <div class="card-header" style="border-bottom-left-radius: 0.25rem; border-bottom-right-radius: 0.25rem;text-align: center;">
                <h5>Para agregar trabajos debe crear primero una cita.</h5>
            </div>
         </div>
         <div v-else >
             <div class="col-md-12" style="padding:0px;">     
                 <trabajosrealizadosoperarios 
                    @trabajomarcado="trabajoMarcado"
                    @marcaoperario="marcaoperario"
                    ref="trabajosoperarios"
                    :actualizartotales="actualizartotales"
                     :recargar="recargar" 
                     :servicio="servicio" 
                     :totalrent="totalrent" 
                     :ocultarcliente="ocultarcliente" 
                     :ocultaroperario="ocultaroperario" 
                     :totalcliente="totalcliente" 
                     :totaloperario="totaloperario"  
                     :id="id" 
                     :operarios="operarios"/>
             </div>
             <div class="col-md-12" style="padding:0px;">            
                 <trabajosrealizadosproveedores
                 @trabajomarcado="trabajoMarcado"
                 ref="reftrabajosproveedores"
                 @marcaproveedor="marcaproveedor"
                 :actualizartotales="actualizartotales"
                     :recargar="recargar" 
                     :servicio="servicio" 
                     :totalrent="totalrent" 
                     :ocultarcliente="ocultarcliente" 
                     :ocultaroperario="ocultaroperario" 
                     :totalcliente="totalcliente" 
                     :totaloperario="totaloperario" 
                     :id="id" 
                     :proveedoreslista="proveedoreslista"
                     :operarios="operarios"
                     :trabajosproveedores="trabajosproveedores"
                     :cargado="cargado"/>
             </div>
         </div>
        </section>
        <!-- Pendiente confirmación -->
        <!-- <Dialog v-model:visible="mostrarModalElba" header="Facturación ELBA" :modal="true" style="width: 90vw; height: 85vh;">
            <iframe :src="elbaUrlBudgeting" style="width:100%; height:75vh; border:none;"></iframe>
        </Dialog> -->
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import TrabajoRealizadoNuevoOperario from './TrabajoRealizadoNuevoOperario.vue';
import trabajosrealizadosoperarios from './TrabajosRealizadosOperario.vue';
import trabajosrealizadosproveedores from './TrabajosRealizadosProveedor.vue';
import trabajosrealizadostotales from './TrabajosRealizadosTotales.vue';
import TrabajoRealizadoNuevoProveedor from './TrabajoRealizadoNuevoProveedor.vue';
import PresupuestosAxa from './PresupuestosAxa.vue';
import ValoracionesAxa from './ValoracionesAxa.vue';
import ValoracionesMutua from './ValoracionesMutua.vue';
// import Dialog from 'primevue/dialog';
export default ({
    props:['id','servicio','actualizarfacturado','auxtrabajos'],
    setup() {
        return;
    },
    components: {
       trabajosrealizadosoperarios,
       trabajosrealizadostotales,
        trabajosrealizadosproveedores,
        TrabajoRealizadoNuevoOperario,
        TrabajoRealizadoNuevoProveedor,
        PresupuestosAxa,
        ValoracionesAxa,
        ValoracionesMutua,
        // Dialog
    },
    data() {
         return {
            mostrarFacturacionMutua:false,
            mostrarFacturacionAxa:false,
            urlglobal:localStorage.getItem("direccion"),
            no_factura: localStorage.getItem('no_factura'),
            mostrarValAxa:false,
            mostrarValMutua: false,
            mostrarPresAxa: false,
            marcadosTodos:false,
            actualizartotales:false,
            ocultarcliente: false,
            ocultaroperario: false,
            colorFactura: '',
            checkfacturar: false,
            test: '',
            recargar: false,
            mostrarnuevooperario:false,
            selectedOption: 'option_b3', 
            operarios: [] ,
            operariostrabajo: '',
            haytrabajos: false,
            mostrarboton: false,
            mostrarnuevoproveedor: false,
            trabajosproveedores: '',
            proveedoreslista:[],
            cargado: false,
            proveedorseleccionado:'',
            mostrarModalElba: false,
            elbaUrlBudgeting: ''
        };
    },
    methods: {
        marcarTrabajos(marcados){
            this.$refs.trabajosoperarios.marcarOperario('',marcados);
            this.$refs.reftrabajosproveedores.marcarProveedor('',marcados);
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key === 'proveedor' || key === 'operario'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                                                            console.log(idop);

                        Object.entries(opprov).forEach(([key2, value2]) => {
                            if(key2 === 'operario' || key2 === 'trabajos'){
                                if(key2 === 'operario'){
                                    value2.trabajos.forEach(trab => {
                                        trab.datos.marcado = marcados;
                                    })
                                }else{
                                    value2.forEach(trab => {
                                        trab.datos.marcado = marcados;
                                    })
                                }
                            }
                        })                        
                    })
                }
            })
        },
        marcaproveedor(proveedor, marcado){
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key === 'proveedor'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                        console.log('idop', idop, proveedor.id);
                        if(idop == proveedor.id){
                            console.log('opop', idop, opprov);
                            opprov.marcado = marcado;
                            Object.entries(opprov).forEach(([key2, value2]) => {
                                if(key2 === 'operario' || key2 === 'trabajos'){
                                    if(key2 === 'operario'){
                                        value2.trabajos.forEach(trab => {
                                            trab.datos.marcado = marcado;
                                        })
                                    }else{
                                        value2.forEach(trab => {
                                            trab.datos.marcado = marcado;
                                        })
                                    }
                                }
                            })
                        }
                    })
                }
            })
            console.log('operariosfinal', this.operarios, proveedor);
        },
        marcaoperario(operario, marcado){
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key == 'operario'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                        if(idop === operario.id){
                            console.log('opop', idop, opprov);
                            opprov.marcado = marcado;
                            Object.entries(opprov).forEach(([key2, value2]) => {
                                if(key2 === 'operario' || key2 === 'trabajos'){
                                    if(key2 === 'operario'){
                                        value2.trabajos.forEach(trab => {
                                            trab.datos.marcado = marcado;
                                        })
                                    }else{
                                        value2.forEach(trab => {
                                            trab.datos.marcado = marcado;
                                        })
                                    }
                                }
                            })
                        }
                    })
                }
            })
            console.log('operariosfinal', this.operarios);
        },
        generarAlbaran(){
            if(this.urlglobal == 'null.pwgs.app'){
                window.open('https://pwgs.raul.pwgs5.interno.apuyen.app/albaran_funciona_nuevo_pdf.php?id_servicio='+this.$props.id,'_blank')
            }else{
                window.open('https://'+this.urlglobal+'/albaran_funciona_nuevo_pdf.php?id_servicio='+this.$props.id,'_blank')
            }
        },
        trabajoMarcado(id, marcado){
            console.log('trabajomarcado', id, marcado, this.operarios);
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key === 'proveedor' || key === 'operario'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                        Object.entries(opprov).forEach(([key2, value2]) => {
                            if(key2 === 'operario' || key2 === 'trabajos'){
                                                                    console.log(idop);

                                if(key2 === 'operario'){
                                    value2.trabajos.forEach(trab => {
                                        console.log('trab', trab);                                        
                                        if(trab.datos.idtrabajo_servicio == id){
                                            trab.datos.marcado = marcado;
                                        }
                                    })
                                }else{
                                    value2.forEach(trab => {
                                        console.log('trab', trab);
                                        if(trab.datos.idtrabajo_servicio == id){
                                            trab.datos.marcado = marcado;
                                        }
                                    })
                                }
                            }
                        })
                    })
                }
            })
        },
        async subsanarMarcados(fecha_subsanacion){
            const api = new PwgsApi();
            var ids = [];
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key === 'proveedor' || key === 'operario'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                        Object.entries(opprov).forEach(([key2, value2]) => {
                            if(key2 === 'operario' || key2 === 'trabajos'){
                                if(key2 === 'operario'){
                                    console.log(idop);
                                    value2.trabajos.forEach(trab => {
                                        console.log('trab', trab);
                                        if(trab.datos.marcado){
                                            ids.push(trab.datos.idtrabajo_servicio);
                                        }
                                    })
                                }else{
                                    value2.forEach(trab => {
                                        if(trab.datos.marcado){
                                            console.log('trab', trab);
                                            ids.push(trab.datos.idtrabajo_servicio);
                                        }
                                    })
                                }
                            }
                        })
                    })
                }
            })
            try{
                await api.put('trabajos/' + this.$props.id + '/subsanar', {ids_trabajos: ids, fecha_subsanacion: fecha_subsanacion});                
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Trabajos subsanados correctamente', life: 2000 });
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
            this.$refs.trabajosoperarios.subsanarTodosMarcados(ids, fecha_subsanacion);
            this.$refs.reftrabajosproveedores.subsanarTodosMarcados(ids, fecha_subsanacion);
        },
        subsanarTrabajos(){
            this.$refs.trabajosoperarios.subsanarTodos();
        },
        marcarTodos(){
            if(this.marcadosTodos){
                this.$refs.trabajosoperarios.cambiarMarcadoTrue();
            }else{
                this.$refs.trabajosoperarios.cambiarMarcadoFalse();
            }
        },
        async quitarfacturar(){
            if(this.checkfacturar == true){
                const api = new PwgsApi();
                const subidadatos = { "facturar_servicio": 0 };
            try {

                await api.put('trabajos/' + this.$props.id + '/facturar-servicio', subidadatos);
                this.checkfacturar = false;
                //this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                setTimeout(() => {
                    
                    this.$parent.cargardatos(this.$props.id,'visita', true);
                    this.$parent.cargarmasdatos();
                }, 1000);
                }
                catch (error) {
                    this.checkfacturar = true;
                   // this.$toast.add({ severity: 'error', summary: "Acción no realizada", detail: error, life: 5000 });
                }

            }

        },
        async cargarproveedores() {
            this.proveedoreslista = []
            const api = new PwgsApi();
            let aux = await api.get('servicios/' + this.$props.id + '/pedidos');
            for (let i = 0; i < aux.datos.length; i++) {
                let repetido = false
                for (let j = 0; j < this.trabajosproveedores.length; j++){
                    if (aux.datos[i].proveedores_idproveedor == this.trabajosproveedores[j]) {
                        repetido = true;
                    }
                 
                }
                if (repetido == false) {
                    let subidadatos = { id: aux.datos[i].proveedores_idproveedor, nombre: aux.datos[i].nombre_proveedor }
                    this.proveedoreslista.push(subidadatos);
                }
            }

        },
        togglecliente() {
            this.selectedOption = 'option_b1'
            this.ocultarcliente = false;
            this.ocultaroperario = true;
        },
        toggleoperario() {
            this.selectedOption = 'option_b2'
            this.ocultaroperario = false;
            this.ocultarcliente = true;
        },
        mostrartodo() {
            this.selectedOption = 'option_b3'
            this.ocultarcliente = false;
            this.ocultaroperario = false;
        },
        togglerecargar(idoper, baremo, eliminar, tipo, confirma, nuevoproveedorcreado) {
            console.log('llegatog', idoper);
            if(idoper && idoper.proveedores_id_proveedor == '0'){
                this.cargardatos(idoper, 'operario', baremo, idoper.idtrabajo_servicio, eliminar, tipo, confirma, nuevoproveedorcreado);
            }else{
                this.cargardatos(idoper, 'proveedor', baremo, idoper.idtrabajo_servicio, eliminar, tipo, confirma, nuevoproveedorcreado);
            }
        },
        async cargardatos(idoper, tipo, baremo, idtrabajo, eliminar, tipotr, confirma, nuevoproveedorcreado) {
            const api = new PwgsApi();
            console.log('cargadatos1');
            var opers = await api.get('trabajos/' + this.id + '/trabajos-servicio');
            var opi = this.operarios;
            console.log('llegacarg', opers, opi);
            this.colorFactura = opers.color_factura ? opers.color_factura : '';
            if(opers.proveedor){
                this.trabajosproveedores = Object.keys(opers.proveedor);                
            }
            this.cargado = !this.cargado;
            //si tenemos el id del operario entramos
            if(idoper){
                console.log('cargadatos2');
                //var opercambio = {};
                /*for(let oper of Object.entries(opers.operario)){
                    if(oper[0] == idoper.operarios_idoperario){
                        opercambio.id = oper[0];
                        opercambio.datos = oper[1];
                    }
                }*/
               //si es un trabajo a operario entramos
               if(tipo == 'operario'){                
                    console.log('operas1', opers.operario);
                    //si ya no existen operarios, es decir se elimina el último trabajo del último operario, entramos
                    if(opers.operario == undefined){       
                        // eliminamos la lista de opararios de nuestra variable de operarios                 
                        delete this.operarios.operario;
                        //vaciamos los operarios de 'trabajosRealizadosOperario'
                        this.$refs.trabajosoperarios.vaciarOperarios();
                        //actualizamos nuestra variable de operarios
                        var aux = this.operarios;
                        this.operarios = {};
                        setTimeout(() => {
                            this.operarios = aux;
                            this.operarios.totales = opers.totales;
                            this.actualizartotales = !this.actualizartotales;                            
                        },500); 
                    //si el operario ya no existe, es decir que se elimina su último trabajo, lo quitamos de nuestra varaible de operarios
                    }else if(opers.operario[idoper.operarios_idoperario] == undefined){
                        //console.log('ssd', this.operarios);
                        //console.log('ssd2', this.operarios.operario[idoper.operarios_idoperario]);
                        //this.operarios.totales.cliente_base -= this.operarios.operario[idoper.operarios_idoperario].totales.cliente;
                        //this.operarios.totales.operario -= this.operarios.operario[idoper.operarios_idoperario].totales.operario.total;

                        //eliminamos el operarios de nuestra lista de operarios de nuestra variable de operarios
                        delete this.operarios.operario[idoper.operarios_idoperario];
                        //actualizamos nuestra variable de operarios
                        var aux2 = this.operarios;
                        this.operarios = {};
                        setTimeout(() => {
                            this.operarios = aux2;
                            this.operarios.totales = opers.totales;
                            this.actualizartotales = !this.actualizartotales;                            
                        },500);
                    //si el oprario sigue teniendo más trabajos entramos aqui                   
                    }else{
                        //this.operarios.operario[idoper.operarios_idoperario] = opers.operario[idoper.operarios_idoperario];
                        console.log('operas2');

                        //si no se trata de una eliminación de trabajo entramos aqui
                        if(baremo || confirma){
                            console.log('trabajooper',this.operarios.operario[idoper.operarios_idoperario]);
                            //actualizamos los datos del operario para ver los cambios en el trabajo afectado
                            this.operarios.operario[idoper.operarios_idoperario] = opers.operario[idoper.operarios_idoperario];
                            console.log('llegabare');         
                        //si es una eliminación entramos aquí (también sirve para nuevos trabajos)
                        }else{
                            console.log('llegabareno');
                            //actualizamos los datos de los totales del operario después de la eliminación
                            this.operarios.operario[idoper.operarios_idoperario] = opers.operario[idoper.operarios_idoperario];

                            //cambio parece que funciona
                            //
                            //Esto había antes
                            //this.operarios.operario[idoper.operarios_idoperario].totales = opers.operario[idoper.operarios_idoperario].totales;
                            //
                            //
                            //
                        }
                        console.log('operarios123', opers.totales);
                        //actualizamos los totales de todos los operarios
                        this.operarios.totales = opers.totales;       
                        //si el operario existe, actualizamos los totales del operario                 
                        if(opers.operario[idoper.operarios_idoperario] != undefined){
                            console.log('operas3');
                            this.$refs.trabajosoperarios.actualiztotales(idoper.operarios_idoperario, this.operarios, baremo, idtrabajo, eliminar, tipotr, confirma);
                        }
                        //actualizamos los totales grobales
                        this.actualizartotales = !this.actualizartotales;
                    }
                //si es un trabajo a proveedor entramos    
                }else{
                    console.log('llegaprov', opers);
                    console.log('llegaprov2',  this.operarios);
                    console.log('prov', idoper);
                    //si ya no existen proveedores, es decir se elimina el último trabajo del último proveedor, entramos
                    if(opers.proveedor == undefined){
                        console.log('prov1');             
                        // eliminamos la lista de proveedores de nuestra variable de operarios     
                        delete this.operarios.proveedor;
                        //vaciamos los proveedores de 'trabajosRealizadosProveedor'
                        this.$refs.reftrabajosproveedores.vaciarOperarios();
                        //actualizamos nuestra variable de operarios
                        var aux3 = this.operarios;
                        this.operarios = {};
                        setTimeout(() => {
                            this.operarios = aux3;
                             this.operarios.totales = opers.totales;
                            this.actualizartotales = !this.actualizartotales;
                        },500);
                    //si el proveedor ya no existe, es decir que se elimina su último trabajo, lo quitamos de nuestra varaible de operarios
                    }else if(opers.proveedor[idoper.proveedores_id_proveedor] == undefined){
                        console.log('prov2', idoper.proveedores_id_proveedor);
                        //eliminamos el proveedor de nuestra lista de proveedores de nuestra variable de operarios
                        console.log('prov2', this.operarios);
                        delete this.operarios.proveedor[idoper.proveedores_id_proveedor];
                        console.log('prov2', this.operarios);
                        //actualizamos nuestra variable de operarios
                        var aux4 = this.operarios;
                        this.operarios = {};
                        setTimeout(() => {
                            this.operarios = aux4;
                             this.operarios.totales = opers.totales;
                            this.actualizartotales = !this.actualizartotales;
                        },500);
                    //si el proveedor sigue teniendo más trabajos entramos aqui
                    }else{
                        //si no existe la lista de proveedores (ya que los que se han creado nuevos todavía no existen en nuestra variable), los creamos
                        if(this.operarios.proveedor == undefined){
                            this.operarios.proveedor = {};
                        }
                        if(this.operarios.proveedor[idoper.proveedores_id_proveedor] == undefined){
                            console.log('prov3 entranuevo'); 
                            this.operarios.proveedor[idoper.proveedores_id_proveedor] = {};
                        }
                        //actualizamos los datos del proveedor para ver los cambios en el trabajo afectado              
                        if(baremo || confirma){
                            this.operarios.proveedor[idoper.proveedores_id_proveedor] = opers.proveedor[idoper.proveedores_id_proveedor];

                        //si es una eliminación entramos aqui(también sirve para nuevos trabajos, si es un proveedor que no tenía y se crea su 
                        // primero nuevoproveedorcreado será true y actualizamos variable operarios para que se recargue con sus datos)
                        }else{
                            console.log('prov3 entramas'); 
                            //actualizamos los datos de los totales del proveedor luego de la eliminación
                            console.log('prov3', this.operarios, idoper.proveedores_id_proveedor);
                            console.log('prov3', opers.proveedor);
                            this.operarios.proveedor[idoper.proveedores_id_proveedor] = opers.proveedor[idoper.proveedores_id_proveedor];
                            if(nuevoproveedorcreado){
                                var aux5 = this.operarios;
                                this.operarios = {};
                                setTimeout(() => {
                                    this.operarios = aux5;
                                },500);
                            }

                            //cambio parece que funciona
                            //
                            //Esto había antes
                            //this.operarios.proveedor[idoper.proveedores_id_proveedor].trabajos = opers.proveedor[idoper.proveedores_id_proveedor].trabajos;
                            //this.operarios.proveedor[idoper.proveedores_id_proveedor].totales = opers.proveedor[idoper.proveedores_id_proveedor].totales;
                            //
                            //
                            //
                        }
                        console.log('prov3', this.operarios);   
                        console.log('operarios', opers.totales);
                        //actualizamos los totales de todos los operarios
                        this.operarios.totales = opers.totales;              
                        //si el proveedor existe, actualizamos los totales del proveedor          
                        if(opers.proveedor[idoper.proveedores_id_proveedor] != undefined){
                            this.$refs.reftrabajosproveedores.actualiztotales(idoper.proveedores_id_proveedor, this.operarios, baremo, idtrabajo, eliminar, tipotr, confirma);
                        }                        
                        //actualizamos los totales grobales
                        this.actualizartotales = !this.actualizartotales;
                    }
                    //obtenemos la nueva lista de proveedoresaux (los vacíos)
                    this.$refs.reftrabajosproveedores.cargarproveedoresaux('auxtrab');
               }               
            }else{
                console.log('cargadatos3');
                this.operarios = opers;
            }
            Object.entries(this.operarios).forEach(([key, value]) => {
                if(key === 'operario' || key === 'proveedor'){
                    Object.entries(value).forEach(([idop, opprov]) => {
                        console.log('opop', idop, opprov);
                        opprov.marcado = 0;
                        if(idop){
                            opprov.id = idop;
                        }
                        Object.entries(opprov).forEach(([key2, value2]) => {
                            if(key2 === 'operario' || key2 === 'trabajos'){
                                if(key2 === 'operario'){
                                    value2.trabajos.forEach(trab => {
                                        trab.datos.marcado = 0;
                                    })
                                }else{
                                    value2.forEach(trab => {
                                        trab.datos.marcado = 0;
                                    })
                                }
                            }
                        })
                    })
                }
            })
            this.cargaroperarios();
            this.cargarproveedores();
            this.mostrarnuevoproveedor = false;
            console.log('operariosfinal', this.operarios);
        },
        comprobarFacturar(){
            if(this.checkfacturar == true && this.operarios.totales.rentabilidad_cia > this.operarios.totales.beneficio.porcentaje){
                this.confirmarFacturar();
            }else{
                this.facturar();
            }
        },
        confirmarFacturar() {
            this.$confirm.require({
                message: 'El expediente está por debajo de la rentabilidad configurada: '+this.operarios.totales.rentabilidad_cia+'%. ¿Desea marcar el servicio para facturar?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.facturar(true);
                },
                reject: () => {
                    this.checkfacturar = false;
                    return;
                }
            });
        },
        async facturar(norentable) { 
            const api = new PwgsApi();
            //alert("facturar "+this.checkfacturar);
            const subidadatos = { "facturar_servicio": this.checkfacturar ? 1 : 0 };
            try {
                if(norentable){
                    subidadatos.no_rentable = 1;
                }
                this.test = await api.put('trabajos/' + this.$props.id + '/facturar-servicio', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                setTimeout(() => {
                    this.$parent.cargardatos(this.$props.id,'visita', true);
                    this.$parent.cargarmasdatos();
                }, 1000);
                }
                catch (error) {
                    this.checkfacturar = false;
                    this.$toast.add({ severity: 'error', summary: "Acción no realizada", detail: error, life: 5000 });
                }
        },
        async cargaroperarios() {
            const api = new PwgsApi();
            let aux = await api.get('trabajos/' + this.$props.id + '/operarios-sin-trabajos');
            this.operariostrabajo = aux.operarios_sin_trabajos;
            this.mostrarboton = true;
            try{
            let aux2 = await api.get('trabajos/' + this.$props.id + '/hay-trabajos');
            this.haytrabajos = aux2.hay_trabajos;
            }catch(error){
                console.log("error");
            }
            let aux3 = await api.get('servicios/' + this.$props.id + '/pedidos');
            console.log("registros",aux3.n_total_registros);
            if(aux3.n_total_registros > 0){
                this.haytrabajos = true;
            }

        },
        comprobarcheck(){
            if(this.servicio){
                if (typeof this.servicio.facturar_servicio !== 'undefined') {                
                    this.checkfacturar = this.servicio.facturar_servicio == "1";
                }
                 
            }
        },
        async comprobarFacturacionAxa(){
            if(this.servicio && this.servicio.compania.sistema=='AXA_WS'){
                const api = new PwgsApi();
                var facturacionAxa = await api.get('parametros-pwgs/axa_facturacion');
                if(facturacionAxa.axa_facturacion == 1){
                    this.mostrarFacturacionAxa = true;
                }else{
                    this.mostrarFacturacionAxa = false;
                }
            }else{
                this.mostrarFacturacionAxa = false;
            }
            if(this.servicio && this.servicio.compania.sistema=='MUTUA'){
                const api = new PwgsApi();
                var facturacionMut = await api.get('parametros-pwgs/mutua_facturacion');
                if(facturacionMut.mutua_facturacion == 1){
                    this.mostrarFacturacionMutua = true;
                }else{
                    this.mostrarFacturacionMutua = false;
                }
            }else{
                this.mostrarFacturacionMutua = false;
            }
        },
        async abrirModalElba(){
            try {
                const api = new PwgsApi();
                const resp = await api.get(`servicios/${this.$props.id}/gremios-elba`); 
                if(resp.urls && resp.urls.budgeting) {
                    window.open(resp.urls.budgeting, '_blank'); 
                }else{
                  this.$toast.add({ severity: 'warn', summary: "Este expediente no tiene enlace ELBA", life: 5000 });
                }
            }catch (e) {
                  this.$toast.add({ severity: 'error', summary: "No se ha podido conectar con ELBA. Intentalo de nuevo en unos minutos.", detail: e, life: 5000 });
            }
            //Para abrir en modal debemos solicitar habilitación de Elba
            //this.elbaUrlBudgeting = resp.urls.budgeting;
            //this.mostrarModalElba = true;
        }
    },
    computed: {
        facturaClass() {
            switch (this.colorFactura) {
                case 'FondoVerde':
                    return 'col-md-4 bg-success disabled card';
                case 'FondoRojo':
                    return 'col-md-4 bg-danger disabled card';
                default:
                    return 'col-md-4 card'; // por si acaso
            }
        }
    },   
    watch: {
        operarios(newVal){
            console.log('cambiaoperss', newVal);
        },
        actualizarfacturado(){
            this.cargardatos();
        },
        cargado() {
            this.cargarproveedores();
        },
        checkfacturar(newVal) {
            //alert("facturar "+this.checkfacturar);            
            // Actualiza colorFactura basado en el nuevo valor de checkfacturar
            if(this.servicio.color_factura == 'FondoVerde' || this.servicio.color_factura == 'FondoRojo'){
                this.colorFactura = newVal ? 'FondoVerde' : 'FondoRojo';
            }else{
                this.colorFactura = '';
            }
        },
        id() { 
            this.cargardatos();
        },
        recargar() {
            this.cargardatos();
        },
        servicio(){
            this.comprobarcheck();            
            this.cargardatos();
            this.comprobarFacturacionAxa();
        },
        auxtrabajos() {
            this.cargardatos();
            this.$refs.reftrabajosproveedores.cargarproveedoresaux('auxtrab');
        }
    },
    mounted() {
        //  de que 'servicio'  disponible y tiene la propiedad 'facturar_servicio'
        this.comprobarcheck();
        this.comprobarFacturacionAxa();
        this.cargardatos();
    },
     activated(){
        console.log('activado');
        this.$refs.reftrabajosproveedores.cargarproveedoresaux('mount');
    },    
})
</script>